<template>
  <div>
    <label
      v-if="!isUploaded"
      :for="uploaderId"
      class="sound-uploader no-text-select"
    >
      <file />
      <br />
      {{ uploadText }}
    </label>
    <el-button v-else type="danger" @click="resetUploading">
      {{ resetText }}
    </el-button>
    <input
      :id="uploaderId"
      type="file"
      limit="1"
      :accept="acceptLine"
      style="display: none;"
      @change="handleUploading"
    />
  </div>
</template>

<script>
import File from "vue-material-design-icons/File.vue";

// @group Editing
// File uploader panel template
export default {
  name: "FileUploader",
  components: {
    File
  },
  props: {
    // Upload button label
    uploadText: {
      type: String,
      default: "Upload"
    },
    // Reset uploading button label
    resetText: {
      type: String,
      default: "Reset"
    },
    // Available file extensions
    acceptTypes: {
      type: Array,
      default: () => []
    },
    // Max size in MB
    sizeLimitMB: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      uploaderId: `edit_sound_uploader-${this._uid}`,
      isUploaded: false
    };
  },
  computed: {
    // @vuese
    // File input 'accept' string parameter
    acceptLine() {
      return this.acceptTypes.length == 0 ? "*" : this.acceptTypes.join();
    }
  },
  methods: {
    // @vuese
    // Check uploaded file size and init it
    handleUploading(e) {
      const file = e.target.files[0];

      if (file.size > Math.round(this.sizeLimitMB * 1024 * 1024)) {
        this.$alert(`File size limit is ${this.sizeLimitMB} MB`);
        return;
      }

      // File successfully uploaded
      this.$emit("uploaded", {
        file: file,
        approve: () => (this.isUploaded = true)
      });
    },
    // @vuese
    // Remove uploaded file
    resetUploading() {
      const fileInput = document.getElementById(this.uploaderId);
      fileInput.value = "";
      this.$emit("reset");
      this.isUploaded = false;
    }
  }
};
</script>

<style scoped>
.sound-uploader {
  display: block;
  background-color: white;
  color: black;
  padding: 1em;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;
}
.sound-uploader:hover,
.sound-uploader:focus {
  background-color: #dfdfdf;
}
.no-text-select {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>
